{
  "INBOX": {
    "ALL": "All",
    "SAVE": "Save",
    "SUBMIT": "Submit",
    "LOADING_CONVERSATION": "We are loading your conversations...",
    "SMS_OUTBOUND_ONLY": "SMS (outbound only)",
    "YOUR_EXPERT": "Your Expert",
    "CANCEL": "Cancel",
    "CLOSE": "Close",
    "CONFIGURE": "Configure",
    "CUSTOMERS": "Customers",
    "SETTINGS_LINK": "Conversations Settings",
    "MORE": "More",
    "DONE": "Done",
    "EDIT": "Edit",
    "NEXT": "Next",
    "DELETE": "Delete",
    "REMOVE": "Remove",
    "CREATE_NEW": "Create new",
    "DATE_CREATED": "Date created",
    "MORE_ACTIONS": "More actions",
    "CONVERSATION_SUMMARY": "Conversation summary",
    "ERROR_GETTING_CONVERSATION_SUMMARY": "Error getting conversation summary, try again later.",
    "SOMETHING_WENT_WRONG": "Something went wrong.",
    "CHAT_HISTORY": "Chat history",
    "NEW_CHAT": "New chat",
    "CONVERSATION_DATE_GROUPS": {
      "TODAY": "Today",
      "YESTERDAY": "Yesterday",
      "LAST_7_DAYS": "Previous 7 days",
      "LAST_30_DAYS": "Previous 30 days",
      "OLDER": "Older"
    },
    "SEND_MESSAGE": {
      "SMS": {
        "ERRORS": {
          "UNSUBSCRIBED": "The recipient has unsubscribed from receiving messages.",
          "ACCOUNT_SUSPENDED": "Your account has been suspended. Please contact support.",
          "MESSAGE_BLOCKED": "Your message was blocked. This can happen if the recipient’s number is blocked from receiving messages.",
          "UNKNOWN_DESTINATION": "The recipient's phone number is invalid or unknown.",
          "MEDIA_SIZE_EXCEEDED": "This file is too large to send. Try compressing it or sending a smaller version.",
          "INVALID_CONTENT_TYPE": "This file type isn’t supported. Try using a different format.",
          "TO_NUMBER_IS_SHORT_CODE": "Messages can’t be sent to short code numbers. Please use a full phone number.",
          "SAME_TO_FROM_NUMBERS": "The 'to' and 'from' numbers cannot be the same. Please check the number you're sending to.",
          "PREMIUM_NUMBER_SENDING_NOT_ALLOWED": "Messages to premium numbers aren’t supported.",
          "MESSAGE_BODY_TOO_LONG": "Your message is too long. Please shorten your message and try again.",
          "MESSAGE_FILTERED": "Your message was blocked by the carrier. It may have triggered spam filters.",
          "REGION_NOT_ENABLED": "Messaging to this country isn’t supported at the moment.",
          "INVALID_TO_NUMBER": "The recipient's number is invalid. Please check the number you're sending to.",
          "TO_NUMBER_IS_LANDLINE": "The recipient’s number is a landline and can’t receive text messages.",
          "TEMPORARY_ISSUE": "A temporary issue occurred. Please try again shortly.",
          "SYSTEM_ERROR": "A system error occurred. Please try again later. If the issue persists, contact support.",
          "A2P_ISSUE": "Your message can’t be sent due to an A2P registration issue. Please contact support to resolve it."
        }
      }
    },
    "EMPTY": {
      "TITLE": "Message your customers",
      "SMS_SUBTITLE": "Start an SMS conversation with your customers",
      "MESSAGE_SUBTITLE": "Start a conversation with your customers",
      "ACTION": "Send a message",
      "LEARN": "Learn about Conversations",
      "ADD_CONTACT": "Add contact",
      "ADD_A_NEW_CONTACT": "Add a new contact",
      "ADD_CONTACT_SECONDARY_MESSAGE": "Start a new conversation by adding a contact",
      "ADD_ACCOUNT": "Add account",
      "ADD_A_NEW_ACCOUNT": "Add a new account",
      "ADD_ACCOUNT_SECONDARY_MESSAGE": "Start a new conversation by adding an account",
      "CONVERSATION_PREVIEW": "New conversation"
    },
    "UNSAVED_CHANGES": {
      "TITLE": "Unsaved changes",
      "MESSAGE": "Are you sure you want to leave? You will lose any unsaved changes.",
      "CONFIRM": "Discard changes"
    },
    "WELCOME": {
      "TITLE": "Welcome to Conversations",
      "SUBTITLE": "Where your team collaborates on great customer service.",
      "SMS_REGISTRATION_LINK_TEXT": "Register to send SMS messages",
      "FB_LINK_TEXT": "Get messages from Facebook",
      "WEBCHAT_LINK_TEXT": "Capture leads from your website"
    },
    "WELCOME_AI_CHAT": {
      "TITLE": "Welcome to AI Assistant Chat",
      "SUBTITLE": "Where you can chat with AI Assistant to help you get stuff done!",
      "CREATE_CONVERSATION_TEXT": "Create conversation"
    },
    "AI": {
      "FALLBACK": {
        "WEBCHAT": "Sorry about this, I'm having trouble answering right now. Don't worry, though! If you confirm your contact information, someone from my team will get back to you as soon as possible."
      }
    },
    "AI_CHAT": {
      "NO_MESSAGES": {
        "TITLE": "Start a conversation with {{assistantName}}",
        "DESCRIPTION": "Get help with your business by asking {{assistantName}} anything. Try one of these suggestions:",
        "DESCRIPTION_WITH_SUGGESTIONS": "Get help with your business by asking {{assistantName}} anything. Try one of these suggestions:",
        "DESCRIPTION_WITHOUT_SUGGESTIONS": "Get help with your business by asking {{assistantName}} anything."
      },
      "SUGGESTIONS": {
        "HELP_GETTING_STARTED": "Help me get started",
        "WALK_THROUGH_FEATURE": "Walk me through a feature",
        "HELP_FIXING_SOMETHING": "Help me fix something",
        "REPUTATION": {
          "WHO_ARE_HAPPIEST_CUSTOMERS": "Who are my happiest customers?",
          "RECURRING_KEYWORDS": "What recurring keywords are appearing in customer feedback?",
          "FEEDBACK_TRENDS": "Are there trends in customer feedback I should be aware of?"
        },
        "SEARCH": {
          "BRAND_VISIBILITY": "What are the customers asking AI about my business?",
          "SEO_AUDIT": "Identify SEO issues on your website"
        }
      },
      "FOOTER": {
        "LABEL": "This conversation is private to you",
        "DESCRIPTION": "This chat is visible only to you, though it may be reviewed to improve support quality. Avoid sharing sensitive or personal information."
      }
    },
    "WELCOME_CHAT_WITH_PARTNER": {
      "SUBTITLE_1": "Questions? We're available to help.",
      "SUBTITLE_2": "Chat directly with the team at {{ partnerBrandName }}."
    },
    "SENDER": {
      "MARK_UNREAD": "Mark conversation as unread",
      "MARK_READ": "Mark conversation as read",
      "EDIT": "Edit",
      "VIEW_CONTACT": "View contact",
      "GO_TO_ACCOUNT": "Go to account",
      "OPEN_BUSINESS_APP": "Open Business App",
      "BLOCK": "Block",
      "UNSUBSCRIBE": "Unsubscribe",
      "OPEN_CONVERSATION": "Open conversation",
      "CLOSE_CONVERSATION": "Close conversation",
      "MARK_AS_CLOSED": "Close conversation",
      "SUMMARIZE_CONVERSATION": "Summarize conversation",
      "TURN_ON_AI_REPLIES": "Turn on AI replies for conversation",
      "TURN_OFF_AI_REPLIES": "Turn off AI replies for conversation"
    },
    "CHAT": {
      "ENTER_MESSAGE": "Enter message",
      "SEND": "Send",
      "SENDING": "Sending ...",
      "TYPING": "Typing ...",
      "FAILED_SENDING": "Failed to send message.",
      "HAS_PHONE_NUMBER": "Messages sent via {{ phone_number }}",
      "NO_PHONE_NUMBER": "You will be assigned an SMS number when you send your first message",
      "MEDIA_NOT_SUPPORTED": "This message contains a media file which cannot be displayed in Conversations currently. You may request they try sending it to you by another method.",
      "INSERT_REVIEW_LINK": "Ask for review",
      "NO_REVIEW_LINKS_FOUND": "Sorry there aren't any review links yet. Add them in {{ cvWhiteLabelName }}",
      "SEND_MESSAGE": "Send message",
      "GET_ACCESS_TO_REVIEW_LINKS": "Get quick access to your review links from many sites and more...",
      "GET_ACCESS_TO_REVIEW_LINKS_CONTACT_US": "Get quick access to your review links from many sites and more. Contact us for more info.",
      "GET_ACCESS_TO_REVIEW_LINKS_ERROR": "Error getting data, please try again later.",
      "CONTACT_US": "Contact us",
      "SETUP_REVIEW_LINKS": "Setup review links",
      "VIA_GOOGLE": "via Google",
      "VIA_FACEBOOK": "via Facebook",
      "VIA_INSTAGRAM": "via Instagram",
      "VIA_WHATSAPP": "via WhatsApp",
      "VIA_SMS": "via SMS",
      "VIA_EMAIL": "via Email",
      "VIA_WEBCHAT": "via Web Chat",
      "VIA_WEB_FORM": "via Form",
      "VIA_PHONE": "via Phone",
      "NEW_FORM_SUBMISSION": "New Submission",
      "UNKNOWN_CONTACT": "Unknown Contact",
      "RESPOND_TO_LEAD_AT_PHONE_NUMBER": "Respond to this lead at {{phone}}.",
      "RESPOND_TO_LEAD_AT_EMAIL": "Respond to this lead at {{email}}.",
      "RESPOND_TO_LEAD_AT_PHONE_NUMBER_OR_EMAIL": "Respond to this lead at {{phone}} or {{email}}.",
      "VIEW_ORIGINAL_MESSAGE": "View original message",
      "AI_WAITING_RESPONSE": "Will be active in",
      "AI_SNOOZED": "Snoozed for",
      "AI_RESPONDER_WAKEUP": "Wake up",
      "AI_RESPONDER_TURN_ON": "Turn on",
      "AI_RESPONDER_ACTIVATED": "AI responder activated",
      "AI_RESPONSE_ENABLED_FOR_CONVERSATION": "Active",
      "AI_RESPONSE_WAITING_POP_OVER": "{{assistantName}} is snoozed and waiting before automatically responding. When the timer reaches zero, and no one from the business has responded yet, {{assistantName}} will wake up and reply to customer messages. Click 'Wake up' to activate immediately.",
      "AI_RESPONSE_ACTIVE_POP_OVER": "{{assistantName}} will automatically respond to inbound messages immediately. When someone from your business sends a message, a wait timer starts to give your team time to respond.",
      "AI_RESPONSE_OFF": "Off",
      "AI_RESPONSE_OFF_POP_OVER": "AI replies are turned off for this conversation. {{assistantName}} will not respond to messages. Click 'Turn on' to enable AI replies.",
      "NOTIFICATIONS_DISABLED": "Your push notifications are disabled.",
      "ALLOW_PUSH_NOTIFICATIONS": "Allow push notifications",
      "WHATS_APP_TEMPLATE_LANGUAGE_LABEL": "Language",
      "NO_TEXT_CONTENT": "[<b>No text content</b>]",
      "EMAIL_CONTENT_HIDDEN": "You don't have permission to view this email.",
      "OPEN_SIDE_PANEL_TOOLTIP": "Open in side panel",
      "LIVE_CHAT_NOT_AVAILABLE": "Live chat is currently not available, please try again later",
      "MESSAGE_RECEIVED_TEXT": "New message",
      "AI_DRAFT": {
        "DRAFT_WITH_AI": "Draft with AI",
        "NO_ASSISTANT": "No AI employee is assigned to this mailbox",
        "REPLACE_CONFIRM_TITLE": "Replace existing draft?",
        "REPLACE_CONFIRM_MESSAGE": "Generating a new AI draft will replace what you've already typed.",
        "REPLACE_CONFIRM": "Replace",
        "EMPTY_RESPONSE": "AI didn't return a draft. Try again.",
        "GENERATION_FAILED": "Couldn't generate an AI draft. Please try again."
      },
      "DELETE_MESSAGE_CONFIRMATION": {
        "TITLE": "Remove message?",
        "DESCRIPTION": "This message will be removed and will not be visible in this conversation. It may still appear in other places where it was sent. This cannot be undone."
      },
      "DELETE_MESSAGE_SUCCESS": "Message removed successfully.",
      "DELETE_MESSAGE_ERROR": "Failed to remove message. Please try again.",
      "HIDE_MESSAGE_TOOLTIP": "Remove message"
    },
    "NEW_MESSAGE": {
      "NEW_MESSAGE": "New message",
      "NEW_MESSAGE_FROM": "New message from",
      "SEND_TO": "Send to:",
      "NAME": "Name",
      "PHONE_NUMBER_OR_CONTACT_NAME": "Phone number or contact name",
      "PHONE_NUMBER_EMAIL_OR_CONTACT_NAME": "Phone number, email or contact name",
      "EMAIL": "E-mail",
      "PHONE": "Phone",
      "FIRST_NAME": "First name",
      "LAST_NAME": "Last name",
      "NAME_OR_PHONE": "Name or phone",
      "CREATE_A_NEW_CONTACT": "Create a new contact",
      "ADD_CONTACT": "Add contact",
      "ADDING_CONTACT": "Adding contact ...",
      "SUGGESTED_CONTACTS": "Suggested contacts",
      "START_CONVERSATION": "Start conversation",
      "CUSTOMER": "Customer",
      "INTERNAL": "Internal",
      "SEND_MESSAGE_TO_TEAM": "Send message to your team members: ",
      "CHOOSE_AN_ACCOUNT": "Choose an account to send a message",
      "CHOOSE_A_CONTACT": "Choose a contact to send a message",
      "ACCOUNT_NAME": "Account name"
    },
    "ADD_CONTACT": {
      "ADD_CONTACT_FORM_HEADER": "Add contact: {{ businessName }}"
    },
    "CHANNEL_STATUS": {
      "CONVERSATION_EXPIRED": "This conversation has expired, and can no longer be replied to.",
      "NO_CUSTOMER_ACCOUNT": "No active customer account is associated with this conversation.",
      "PROVIDER_NOT_ENABLED": "Message provider is not enabled.",
      "CUSTOMER_EMAIL_REQUIRED": "Customer email address is required.",
      "UNAVAILABLE_IN_LOCATION": "Message provider is not available in the current location",
      "CUSTOMER_PHONE_REQUIRED": "Customer phone number is required.",
      "WHATSAPP_MESSAGE_TEMPLATES_ONLY": "Initial message limited to approved templates",
      "WHATSAPP_MESSAGE_TEMPLATES_ONLY_BUT_PENDING_APPROVAL": "Sending via WhatsApp not yet available; awaiting WhatsApp approval. Monitor at ",
      "CUSTOMER_UNSUBSCRIBED_SMS": "Customer has unsubscribed from SMS messages.",
      "CUSTOMER_UNSUBSCRIBED_EMAIL": "Customer has unsubscribed from email messages."
    },
    "ERROR": {
      "PERMISSION": "Sorry, you don't have permission to send a message in this chat",
      "PERMISSION_DENY": "You are currently unable to access partial conversations. Please reach out to your system administrator for the necessary permissions.",
      "CHAT_DELETED": "Sorry, this channel is inactivated to receive new messages",
      "CREATE_CONTACT": "Sorry, could not create contact",
      "CORRECT_INVALID_REQUIRED_FIELDS": "Please correct the required or invalid fields",
      "THE_MESSAGE_IS_EMPTY": "The message is empty",
      "NO_CONTACT_SELECTED": "Select a contact or enter a valid phone number to send a message",
      "INVALID_CONTACT_SELECTED": "Select an existing contact or provide a valid email address or phone number to send a message",
      "INVALID_ACCOUNT_SELECTED": "Select an existing account",
      "CONTACT_EXISTS": "A contact already exists with that phone number and/or email",
      "UNSUPPORTED_PHONE_NUMBER": "Unsupported number. Please try a different number, or select a contact from search results.",
      "INVALID_PHONE_NUMBER": "The phone number is invalid",
      "INVALID_INPUT": "The provided phone number or email is invalid",
      "DELETED_CUSTOMER": "Deleted Customer",
      "REQUIRED_FIELD": "This field is required",
      "INVALID_LENGTH_TOO_FEW_CHARACTERS": "Must be {{ min }} characters or more",
      "INVALID_EMAIL_ADDRESS": "Invalid email address",
      "PHONE_OR_EMAIL_REQUIRED": "A phone number or email address is required",
      "NO_PHONE_NUMBER": "Sorry, you are unable to send messages to this contact, as no phone number has been provided.",
      "NO_PHONE_NUMBER_OR_EMAIL": "Sorry, you are unable to send messages to this contact, as no phone number or e-mail has been provided.",
      "BROKEN_MEDIA_URL": "Image is expired or unavailable",
      "ORIGINAL_MSG_CONTENT_NOT_AVAILABLE": "Original message content is not available",
      "CONVERSATION_DETAILS": "Error getting conversation details",
      "SEND_REVIEW_REQUEST": "Error sending review request",
      "REVIEW_REQUEST_ALREADY_SCHEDULED": "A review request is already scheduled for this account and contact(s)",
      "MESSAGE_ERROR": {
        "UNABLE_TO_DELIVER": "Unable to deliver message. The recipient's phone number may not be a WhatsApp number.",
        "PAYMENT_ISSUE": "There was an error related to your payment method. Please ensure a payment method is set on your WhatsApp Business Account and that your Facebook Business has a valid address.",
        "PHONE_NUMBER_REGISTRATION": "There was an issue with your phone number registration. Please register before trying again.",
        "MORE_THAN_24_HOURS": "More than 24 hours have passed since the last message or the recipient has never sent a message. Please use a message template instead."
      },
      "UNABLE_TO_CREATE_CONVERSATION": "There was an issue creating a conversation. Please contact support or try again later",
      "WHATSAPP_TEMPLATE": {
        "CONTACT_MUST_HAVE_NAME": "The contact must have a first name to send this template. Add a first name to the contact and try again."
      },
      "LOAD_CONVERSATIONS": "We couldn't load your conversations. Please try again.",
      "LOAD_MESSAGES": "We couldn't load your messages. Please try again."
    },
    "POPOVER": {
      "BUSINESS_INITIATED_CONVERSATIONS": "Conversations SMS Number",
      "BUSINESS_INITIATED_CONVERSATIONS_DETAIL": "Your business is assigned an SMS number. You can share this number with customers. Please note, this number is for SMS text messages only. Calls cannot be received at this number.",
      "IN_PLATFORM_CHANNEL_MESSAGE_INFO": "Messages will be sent directly through the platform, and recipients will be notified.",
      "GOOGLE_BUSINESS_COMMUNICATIONS_CHANNEL_MESSAGE_INFO": "<p>This customer is reaching out via your business listing on Google Maps or Google Search. Your response will be delivered to them via Google Business Messages, and the customer can reply directly from your listing.</p><p>This conversation will automatically expire 30 days after the customer's last response. We recommend asking for their phone number or email address if you want to retain this customer.</p>",
      "NO_PHONE_NUMBER_PROVISIONED": "You will automatically be assigned a local SMS number when you send your first message.",
      "IMPERSONATION_TITLE": "You're impersonating another user",
      "IMPERSONATION_TEXT": "Before sending messages from Conversations, make sure you're not impersonating another user."
    },
    "INFO": {
      "DELETED": "Deleted",
      "PARTNER_PLATFORM_LABEL": "Messages sent via platform",
      "GOOGLE_BUSINESS_COMMUNICATIONS_LABEL": "Google Business Messages",
      "CONVERSATION_DETAILS": "Conversation details",
      "CONVERSATION_STATUS_OPENED": "Conversation opened",
      "CONVERSATION_STATUS_CLOSED": "Conversation closed",
      "AI_RESPONSES_ENABLED": "AI responses are enabled for this conversation",
      "AI_RESPONSES_DISABLED": "AI responses are disabled for this conversation",
      "SHARED_MEDIA": "Shared media"
    },
    "LABELS": {
      "VENDOR": "Vendor",
      "PARTNER": "Partner",
      "ACCOUNT": "Account",
      "CONTACT": "Contact",
      "CUSTOMER": "Customer",
      "APP": "App",
      "INACTIVE": "Inactive",
      "ACCOUNT_DELETED": "Account Deleted",
      "PRIVATE": "Private"
    },
    "TERMS_OF_SERVICE": {
      "TITLE": "Terms of Service",
      "FULL_TITLE": "Conversations Terms of Service",
      "INTRO_FIRST_LINE": "To continue, you need to agree to the ",
      "ACCEPTANCE_MESSAGE": "I have read and agree to the Terms of Service"
    },
    "COMMON": {
      "ACTION_LABELS": {
        "DECLINE": "Decline",
        "ACCEPT": "Accept",
        "AGREE": "Agree",
        "GO_BACK": "Go back",
        "COPY": "Copy"
      },
      "SNACK_BAR_MESSAGE": {
        "COPY_SUCCESS": "Copied to clipboard",
        "CLICK_TO_COPY": "Click to copy"
      }
    },
    "REQUEST_PAYMENT": {
      "TITLE": "Send invoice",
      "ITEM_DESCRIPTION": "Item description",
      "DUE_DATE": "Due date",
      "ADD_LINE": "Add line",
      "DESCRIPTION": "Description",
      "PRICE": "Price",
      "SUBTOTAL": "Subtotal",
      "TAX": "Tax",
      "TAX_TOOLTIP": "Tax is automatically calculated using the best matching tax rate.",
      "CONFIGURE_TAX_RATES": "Configure tax rates",
      "AMOUNT_DUE": "Amount due",
      "CANCEL": "Cancel",
      "CREATE": "Create invoice",
      "VIEW_INVOICES": "View invoices",
      "INVOICE_CREATE_SUCCESS": "Invoice created",
      "INVOICE_CREATE_ERROR": "Failed to create invoice. Please try again."
    },
    "REQUEST_REVIEW": {
      "TITLE": "Send review request?",
      "CONTENT": "You're about to send a review request to {{ customerName }}.",
      "SEND_REQUEST": "Send request"
    },
    "UPLOAD_FILE": {
      "TITLE": "Add file",
      "SUCCESSFUL_UPLOAD": "Successfully uploaded {{fileName}} file",
      "MAX_FILES_EXCEEDED": "Only one attachment per message. Send message or remove attachment to add another.",
      "MAX_MEDIA_FILES_EXCEEDED": "Up to 5 attachments per message. Send message or remove an attachment to add more.",
      "MAX_FILE_SIZE_EXCEEDED_ARG": "Max file size of {{maxFileSize}} exceeded ({{channel}} messaging limit). Please use a different file",
      "VOICE_RECORDING": {
        "TITLE": "Record audio clip",
        "STOP_RECORDING": "Stop recording",
        "MIC_ERROR": "Microphone access denied. Please allow microphone permissions and try again."
      },
      "VOICE_TRANSCRIPTION": {
        "TITLE": "Voice to text",
        "STOP_TRANSCRIPTION": "Stop transcription",
        "ERROR": "Failed to transcribe audio. Please try again.",
        "NO_TEXT_DETECTED": "No speech detected. Please try again.",
        "TRANSCRIBING": "Transcribing..."
      }
    },
    "MESSAGE_TEMPLATES": {
      "TITLE": "Insert templated message",
      "MODAL": {
        "EDIT_TEMPLATES": "Edit",
        "CREATE_TEMPLATE": "Create template",
        "EMPTY_STATE_TITLE": "Messaging Templates",
        "EMPTY_STATE_CONTENT": "There are no message templates yet. Customize your templates or create a new one and save time when responding to messages in your Conversations.",
        "ERROR": "Error inserting template, please try again"
      },
      "FIELDS_NOT_ALL_HYDRATED": "Some dynamic fields could not be populated. Please update them manually."
    },
    "PREVIEW_PANE": {
      "TITLE": "Conversations messages",
      "GO_TO_INBOX": "Go to Conversations",
      "EMPTY_STATE": {
        "INFO": "Start a conversation with this account.",
        "SEND_MESSAGE": "Send a message"
      },
      "LOAD_MORE": "Load more",
      "CURRENT_USER": "You",
      "DELETED_USER": "Deleted User",
      "SHARED_A_FILE": "Shared a file"
    },
    "HEADER": {
      "TITLE": "Conversations",
      "BETA": "BETA",
      "INBOX_AI_TITLE": "{{assistantName}}",
      "TOOLTIP": "{{assistantName}} - Your AI Assistant",
      "AI_ASSISTANT_INBOX_TITLE": "Chat",
      "AI_MENU_TOOLTIP_SHOW_HISTORY": "Chat history",
      "AI_MENU_TOOLTIP_SHOW_CHAT": "Show chat"
    },
    "TOPBAR": {
      "ASSIGNEE": "Assignee",
      "ASSIGN_TO": "Assign to…",
      "ASSIGN_CLEAR": "Clear assignment",
      "NONE": "None",
      "ERROR_LOADING_RECIPIENT": "Error loading recipients information"
    },
    "STRIP": {
      "ASSIGN": "Assign",
      "REASSIGN": "Reassign",
      "REMOVE_ASSIGNEE": "Remove Assignee",
      "ASSIGN_TO_ME": "Assign to me",
      "SEARCH_USERS": "Search users…",
      "NO_USERS_FOUND": "No users found",
      "ASSIGN_CONVERSATION": "Assign conversation",
      "REASSIGN_CONVERSATION": "Reassign conversation from {{name}}"
    },
    "COMPOSER_ALERTS": {
      "PARTICIPANT_INTERNAL_INFO_DELETED": {
        "TITLE": "Deleted contact",
        "DESCRIPTION": "The contact you are trying to reach has been deleted."
      }
    },
    "SETTINGS": {
      "PAGE_TITLE": "Conversations settings",
      "CHAT_AVAILABILITY": "Chat availability",
      "DISPLAY_AVAILABILITY_MESSAGE": "Display availability message",
      "AVAILABILITY_DESCRIPTION": "All recipients in conversations with you will see your organization's availability message at the top of their message window",
      "AVAILABILITY_MESSAGE": "Availability message",
      "PREVIEW_TITLE": "Preview",
      "SAVE_SUCCESSFUL": "Settings saved successfully",
      "ERROR_SAVING_SETTINGS": "Error saving settings",
      "ERROR_LOADING_SETTINGS": "Error loading settings",
      "PREVIEW": {
        "TITLE": "Organization Name"
      },
      "AUTOMATIONS": "Automations",
      "AUTOMATIONS_DESCRIPTION": "You can further enhance Conversations features by creating automated workflows.",
      "GO_TO_AUTOMATIONS": "Go to Automations",
      "LEARN_MORE": "Learn more",
      "EMPTY_STATE": {
        "TITLE": "Conversations settings coming soon",
        "DESCRIPTION": "We're working on ways to let you customize your Conversations. Stay tuned."
      },
      "ACTIVE": "Active",
      "INACTIVE": "Setup required",
      "DISCONNECT": "Disconnect",
      "AI_ASSISTANT": {
        "TITLE": "AI Employee"
      },
      "FACEBOOK_MESSENGER": {
        "TITLE": "Facebook Messenger",
        "DESCRIPTION": "Receive and respond to Facebook messages.",
        "DISCONNECTED_DESCRIPTION": "Connect a verified account to gain access to Facebook messages.",
        "FACEBOOK_PAGE_NAME": "Facebook Page",
        "CONNECT": "Connect Facebook",
        "SIGN_IN_TO_FACEBOOK": "Sign in with Facebook",
        "RECONNECT": "Reconnect",
        "TURN_ON_MESSAGING": "Turn on messaging",
        "DISCONNECT": "Disconnect",
        "DISCONNECT_TITLE": "Are you sure you want to disconnect Facebook Messenger?",
        "DISCONNECT_DESCRIPTION": "You will no longer be able to receive or respond to messages from Facebook Messenger.",
        "SUCCESS": {
          "SUCCESSFULLY_ENABLED": "Successfully enabled Facebook Messenger",
          "SUCCESSFULLY_DISABLED": "Successfully disabled Facebook Messenger"
        },
        "WARNINGS": {
          "MULTIPLE_PAGES_LINKED": "Multiple Facebook Pages linked",
          "MULTIPLE_PAGE_FIRST_SELECTED": "The page you will setup for Facebook Messenger is <strong>{{ pageName }}</strong>.",
          "MULTIPLE_PAGES_LINKED_DESCRIPTION": "You have linked multiple Facebook pages to your account but may only use one with Conversations AI."
        },
        "ERRORS": {
          "MESSENGER_ALREADY_ENABLED_ON_OTHER_BUSINESS": "The business '{{ organizationName }}' is already receiving Messenger messages for this Facebook page. Either disable messaging on '{{ organizationName }}' or connect a different Facebook page here.",
          "MESSENGER_ALREADY_ENABLED_ON_OTHER_UNKNOWN_BUSINESS": "Another business is already receiving Messenger messages for this Facebook page. Either disable messaging on the other business or connect a different Facebook page here.",
          "FAILED_TO_ENABLE": "Failed to enable Facebook Messenger. Please contact support if the issue persists.",
          "FAILED_TO_DISABLE": "Failed to disable Facebook Messenger. Please contact support if the issue persists.",
          "UNKNOWN_ERROR": "An unknown error occurred.",
          "PERMISSIONS_ERROR": "A permissions error occurred.",
          "PERMISSIONS_ERROR_DESCRIPTION": "You do not have the necessary permissions to make changes to this connection. Please contact support for assistance.",
          "PLEASE_TRY_RECONNECTING": "Please try reconnecting.",
          "TOKEN_EXPIRED": "Your Facebook connection has expired.",
          "TOKEN_EXPIRED_DESCRIPTION": "Please sign in again to restore your Facebook Messenger connection.",
          "RECONNECT_TO_GRANT_PERMISSIONS": "Please reconnect to Facebook to grant additional messaging permissions for your Facebook page.",
          "CANNOT_SEND_MESSAGE": "Unable to reply with Facebook Messenger",
          "CANNOT_SEND_MESSAGE_DESCRIPTION": "An error occurred getting the status of this Facebook message."
        }
      },
      "GOOGLE_BUSINESS_MESSAGES": {
        "ACTIONS": {
          "GO_TO_SETTINGS": "Go to settings"
        },
        "STATUS": {
          "NOT_LAUNCHED": {
            "TITLE": "Business Messages is not enabled",
            "DESCRIPTION": "Google Business Messages has been disabled for this account. You can re-enable it by visiting the Conversations Settings page."
          },
          "NOT_ENABLED": {
            "TITLE": "Business Messages is disabled",
            "DESCRIPTION": "Google Business Messages is disabled for this account. To enable it, please contact your account administrator."
          },
          "EXPIRED_CONVERSATION": {
            "TITLE": "Conversation has expired",
            "DESCRIPTION": "Google Business Messages conversations expire after 30 days from the customer's last message, and responses can no longer be provided beyond that point."
          },
          "UNKNOWN_ERROR": {
            "TITLE": "Unknown error",
            "DESCRIPTION": "An unknown error occurred. Please contact support, or try again later."
          },
          "INVALID_TOKEN": {
            "TITLE": "Google Business Profile disconnected",
            "DESCRIPTION": "This conversation was initiated from your Google Business Profile, but your profile is no longer connected. To continue the conversation, please reconnect your profile."
          }
        }
      },
      "INSTAGRAM_MESSAGES": {
        "TITLE": "Instagram Messages",
        "DESCRIPTION": "Receive and respond to Instagram Messages.",
        "DISCONNECTED_DESCRIPTION": "Connect through Facebook with a verified account to gain access.",
        "SIGN_IN_TO_INSTAGRAM": "Sign in with Instagram",
        "INSTAGRAM_PAGE_NAME": "Connected account",
        "CONNECT": "Connect Instagram",
        "RECONNECT": "Reconnect",
        "TURN_ON_MESSAGING": "Turn on messaging",
        "DISCONNECT": "Disconnect",
        "DISCONNECT_TITLE": "Are you sure you want to disconnect Instagram Messages?",
        "DISCONNECT_DESCRIPTION": "You will no longer be able to receive or respond to Instagram Messages.",
        "SUCCESS": {
          "SUCCESSFULLY_ENABLED": "Successfully enabled Instagram Messages",
          "SUCCESSFULLY_DISABLED": "Successfully disabled Instagram Messages"
        },
        "WARNINGS": {
          "MULTIPLE_PAGES_LINKED": "Multiple Instagram Pages linked",
          "MULTIPLE_PAGE_FIRST_SELECTED": "The page you will setup for Instagram Messages is <strong>{{ pageName }}</strong>.",
          "MULTIPLE_PAGES_LINKED_DESCRIPTION": "You have linked multiple Instagram pages to your account but may only use one with Conversations AI."
        },
        "ERRORS": {
          "FAILED_TO_ENABLE": "Failed to enable Instagram Messages. Please contact support if the issue persists.",
          "FAILED_TO_DISABLE": "Failed to disable Instagram Messages. Please contact support if the issue persists.",
          "UNKNOWN_ERROR": "An unknown error occurred.",
          "PERMISSIONS_ERROR": "A permissions error occurred.",
          "PERMISSIONS_ERROR_DESCRIPTION": "You do not have the necessary permissions to make changes to this connection. Please contact support for assistance.",
          "PLEASE_TRY_RECONNECTING": "Please try reconnecting.",
          "RECONNECT_TO_GRANT_PERMISSIONS": "Please reconnect to Instagram to grant additional messaging permissions for your Instagram page.",
          "CANNOT_SEND_MESSAGE": "Unable to reply with Instagram Messages",
          "CANNOT_SEND_MESSAGE_DESCRIPTION": "This conversation has expired, or there is an issue with the Instagram connection."
        }
      },
      "WHATSAPP_MESSAGES": {
        "TITLE": "WhatsApp Business Messages",
        "DESCRIPTION": "Receive and respond to WhatsApp Business messages.",
        "ESTABLISHING_CONNECTION_PLEASE_WAIT": "Establishing connection, please wait...",
        "REMOVING_CONNECTION_PLEASE_WAIT": "Removing connection, please wait...",
        "NOT_CONNECTED_DESCRIPTION": "Connect through Facebook with a verified account to gain access.",
        "CONNECTED_PHONE_NUMBER": "Connected phone number",
        "LOGIN_WITH_FACEBOOK": "Sign in with Facebook",
        "RECONNECT": "Reconnect",
        "DISCONNECT": "Disconnect",
        "DISCONNECT_TITLE": "Are you sure you want to disconnect your WhatsApp account?",
        "DISCONNECT_DESCRIPTION": "You will no longer be able to receive or respond to WhatsApp messages.",
        "SUCCESS": {
          "SIGNUP_SUCCESSFUL": "Successfully setup WhatsApp connection",
          "DISCONNECT_SUCCESSFUL": "Successfully removed WhatsApp connection"
        },
        "ERRORS": {
          "SIGNUP_NOT_SUCCESSFUL": "Failed to setup WhatsApp connection. Please contact support if the issue persists.",
          "DISCONNECT_NOT_SUCCESSFUL": "Failed to remove WhatsApp connection. Please contact support if the issue persists.",
          "UNKNOWN_ERROR": "An unknown error occurred.",
          "PERMISSIONS_ERROR": "A permissions error occurred.",
          "PLEASE_TRY_RECONNECTING": "Please try reconnecting.",
          "CANNOT_SEND_MESSAGE_DESCRIPTION": "This conversation has expired, or there is an issue with the WhatsApp connection.",
          "DISCONNECTED_ON_PHONE_TITLE": "Connection no longer valid",
          "DISCONNECTED_ON_PHONE_DESCRIPTION": "You've disconnected WhatsApp from your phone, or the connection is no longer valid."
        },
        "REMOVE_CONNECTION": "Remove connection",
        "BADGE": {
          "CONNECTED": "Connected",
          "NOT_CONNECTED": "Setup required",
          "SETUP_STEPS_INCOMPLETE": "Setup required",
          "TOKEN_INVALID": "Invalid token",
          "UNKNOWN": "Unknown",
          "UNKNOWN_ERROR": "Unknown error"
        },
        "COEXISTENCE": {
          "TITLE": "How to disconnect from WhatsApp",
          "DESCRIPTION": "To disconnect, follow these steps in the WhatsApp Business app on your phone:",
          "STEP_1": "Open the WhatsApp Business app on your phone",
          "STEP_2": "Go to <strong>Settings</strong> > <strong>Account</strong> > <strong>Business Platform</strong>",
          "STEP_3": "Tap the app <strong>business name</strong> and then <strong>Disconnect</strong>",
          "AFTER_DISCONNECT_REMOVE": "After you've disconnected on your phone, click below to remove the connection from our system.",
          "STILL_CONNECTED_MESSAGE": "Please disconnect WhatsApp on your phone first, then try again."
        }
      },
      "EMAIL": {
        "UNSUPPORTED_FOR_PARTNER_CENTER": {
          "TITLE": "Email is not available",
          "DESCRIPTION": "Sorry, you are unable to send messages to this contact, as email is not available."
        },
        "NOT_ENABLED": {
          "TITLE": "Email is not available",
          "DESCRIPTION": "Email messaging requires a paid {{productName}} subscription. Please upgrade to send emails."
        }
      },
      "SMS_MESSAGES": {
        "COMPOSER_A2P_REGISTRATION_REQUIRED": {
          "TITLE": "SMS Registration Required",
          "DESCRIPTION": "SMS Registration Required – US telecom companies require businesses to register to send SMS messages. Register your business to continue this conversation via SMS.",
          "ACTION_TITLE": "View registration"
        },
        "COMPOSER_REGULATORY_COMPLIANCE_REQUIRED": {
          "TITLE": "SMS Regulatory Compliance Required",
          "DESCRIPTION": "SMS regulatory compliance is required in your country before sending SMS messages. Complete the regulatory compliance process to continue this conversation via SMS.",
          "ACTION_TITLE": "Complete compliance"
        },
        "NOT_ENABLED": {
          "TITLE": "SMS messaging is not available",
          "DESCRIPTION": "Sorry, you are unable to send messages to this contact, as SMS messaging is not enabled. Please contact support for assistance."
        },
        "NO_PHONE_NUMBER": {
          "TITLE": "SMS messaging is not available",
          "DESCRIPTION": "SMS phone number not available. Please contact support if the issue persists."
        },
        "CARD": {
          "PHONE_AND_SMS": "Phone and SMS",
          "ASSIGNED_NUMBER_TITLE": "Assigned Number",
          "ASSIGNED_NUMBER_DESCRIPTION": "Your number is automatically assigned based on available options in your area.",
          "ENABLED_AI_RESPONSES": "Enable AI responses",
          "ENABLED_AI_RESPONSES_DESCRIPTION": "AI can respond to incoming SMS messages.",
          "AI_RESPONSES_UPDATED": "AI SMS responses setting updated successfully.",
          "AI_RESPONSES_UPDATE_ERROR": "Error updating AI SMS responses setting.",
          "SETTINGS": "Settings",
          "LEARN_MORE": "Learn more",
          "CONFIGURE": "Configure",
          "PHONE_NUMBER_CLAIM_SUCCESS": "Phone number claimed with success",
          "PHONE_NUMBER_CLAIM_ERROR": "Error claiming phone number",
          "CLAIM_PHONE_NUMBER": "Claim phone number",
          "SENDER_ID_TITLE": "SMS sender ID (outbound only)",
          "SENDER_ID_DESCRIPTION": "Your alphanumeric sender ID is the name recipients see when they receive an SMS from your business."
        }
      },
      "PHONE_NUMBER_SETTINGS": {
        "BUTTON_LABEL": "Settings",
        "TITLE": "Phone number settings",
        "INCOMING_CALL_HANDLE_TITLE": "When a call is received...",
        "INCOMING_SMS_HANDLE_TITLE": "When you receive an SMS...",
        "YOUR_NUMBER": "Your number:",
        "YOUR_SENDER_ID": "Your SMS sender ID (outbound only):",
        "PHONE_CONFIG_SAVED": "Phone number config saved",
        "PHONE_CONFIG_ERROR": "Failed to save phone number config",
        "PARTNER_SMS_BETA_MESSAGE": "Unlimited SMS sending and receiving is currently included with your subscription during our open beta! Later, some messaging will be included as part of your subscription with the option to pay for more as needed.",
        "FORWARD_MISSED_CALL_INFO": "To trigger missed-call text back and enable AI call handling on your existing business phone line, you can forward callers from your line to the one we've provided you when certain conditions are met. Most carriers support conditional forwarding with easy star-codes.",
        "FORWARD_MISSED_CALL_LEARN_MORE": "Use our features with your existing business number",
        "HOW_TO_USE_QUICK_CODES": "How to set up call forwarding:\n1. On your business phone, dial the activation code listed below.\n2. You'll get a confirmation from your phone company.\n3. To make sure it worked, call your business number from another phone.\n4. Want to turn it off later? Just dial the cancel code or #004# to reset your phone settings to default.",
        "HOW_TO_USE_LANDLINE_QUICK_CODES": "How to setup forwarding from a landline:\n1. Dial the activation code\n2. Wait for dial tone\n3. Dial the forwarding number: {{phoneNumber}}\n4. Wait for confirmation tone\n5. Hang up and test by calling from another phone\n6. To turn it off, dial the cancel code",
        "CALL_OPTIONS": {
          "NOTHING": "End call",
          "VOICE_AI": "Answer with AI",
          "FORWARD_CALL": "Forward the call",
          "USE_BROADLY": "Handle with Broadly 1.0",
          "SEND_FOLLOWUP_MESSAGE": "Send SMS message",
          "ALPHANUMERIC_NOT_REGISTERED": "SMS settings are unavailable because this account does not have a registered alphanumeric sender ID. Contact support to register one."
        },
        "PHONE_INPUT": {
          "SEARCH_COUNTRY": "Search country...",
          "NO_COUNTRIES_FOUND": "No countries found",
          "INVALID_COUNTRY_CODE": "Invalid country code",
          "VALIDATION_ERROR": "Please enter a valid phone number"
        },
        "SMS_OPTIONS": {
          "NOTHING": "Do nothing",
          "AI_REPLY": "Reply with AI"
        },
        "VOICE_AI": {
          "ENABLED_LABEL": "Answer with voice AI",
          "ENABLED_INFO": "Call forwarding and missed call messaging are not available while your voice receptionist is answering calls.",
          "DISABLED_INFO": "Your voice receptionist can be configured to answer calls. Note that using this feature will disable call forwarding and missed call messaging.",
          "TELL_CALLER_RECORDING": "Tell the caller the call is being recorded",
          "UPGRADE_FOR_ACCESS": "Upgrade to gain access"
        },
        "CALL_FORWARDING": {
          "ENABLED_LABEL": "Forward the call",
          "FORWARDING_NUMBER_LABEL": "Forward to",
          "FORWARDING_NUMBER_HINT": "Incoming calls to your platform number will be forwarded to this number",
          "FORWARDING_NUMBER_INVALID": "Phone number must contain international dialing code and area code",
          "FORWARD_TO_TOOLTIP": "Enter the number for your answering service, personal device, or phone tree. This is not your regular business number."
        },
        "END_CALL_MESSAGE": {
          "PLAY_VOICE_MESSAGE": "Play a voice message before ending the call (text-to-speech audio)\n",
          "LABEL": "Voice message",
          "PLACEHOLDER": "Sorry we missed you call. We'll send you a text shortly"
        },
        "MISSED_CALL_MESSAGING": {
          "ENABLED_LABEL": "Follow up with an SMS message",
          "ENABLED_LABEL_SENDER_ID": "Follow up with an SMS message via {{senderId}} (outbound only)",
          "ENABLED_LABEL_MISSED_CALL": "Follow up with an SMS message when the call is missed",
          "ENABLED_LABEL_MISSED_CALL_SENDER_ID": "Follow up with an SMS message via {{senderId}} (outbound only) when the call is missed",
          "TRIGGER_LABELS": {
            "IMMEDIATE": "Immediately",
            "FORWARDED_CALL_MISSED": "If the forwarded call is missed"
          },
          "IMMEDIATE_MESSAGE_TOOLTIP": "Recommended when forwarding to an answering service or voicemail",
          "FORWARDED_CALL_MISSED_TOOLTIP": "Recommended when forwarding to a personal device or phone tree",
          "FORWARDED_CALL_MISSED_HINT": "A call is considered missed if it disconnects or receives a busy tone. Calls answered by voicemail are considered 'answered' and won't trigger a text back.",
          "MESSAGE_CONTENT_LABEL": "Message to send",
          "MESSAGE_CONTENT_LABEL_WHEN_CALL_ENDS": "Message to send when call ends",
          "VOICE_AI_EXAMPLE_FOLLOW_UP_MESSAGE": "e.g, Hi! Thanks for calling [business name]. You can text us here if you have any more questions",
          "CALL_FORWARDING_EXAMPLE_FOLLOW_UP_MESSAGE": "e.g, Hi, this is [Your Business Name]. We missed your call. How can we help? Reply to this message and we'll get back to you soon. Reply STOP to opt out.",
          "SEND_SMS_FOLLOW_UP_MESSAGE": "e.g, Hi, this is [Your Business Name]. We missed your call. How can we help? Reply to this message and we'll get back to you soon. Reply STOP to opt out."
        },
        "QUICK_SETUP_CODES": {
          "HEADER": "Quick Setup Codes",
          "ACTIVATE": "Activate:",
          "CANCEL": "Cancel:",
          "GSM_MOBILE_TITLE": "Mobile",
          "LANDLINE_TITLE": "Landline",
          "NO_ANSWER_TITLE": "Forward calls if you don't answer (after 10 seconds)",
          "PHONE_OFF_TITLE": "Forward calls if your phone is off or has no signal",
          "LINE_BUSY_TITLE": "Forward calls if you're on another call or you decline",
          "LANDLINE_FORWARD_ALL_TITLE": "Forward all incoming calls immediately",
          "LANDLINE_BUSY_TITLE": "Forward calls when line is busy",
          "LANDLINE_NO_ANSWER_TITLE": "Forward calls when no answer"
        }
      },
      "MANAGE_ON_WEB": "Manage on web",
      "MANAGE_ON_WEB_ERROR": "Failed to open the web page.",
      "SMS_REGISTRATION": "Phone & SMS Registration",
      "INBOX_SETTINGS": "Conversations Settings",
      "A2P_REGISTRATION": {
        "TITLE": "Before You Submit: Improve your chances of SMS Approval",
        "BOLD_BODY": "When reviewing your application, telephone carriers will manually check your website to ensure SMS opt-in compliance. ",
        "BODY": "If they cannot find the following elements, your registration may be rejected. Follow this guide to ensure your business’s website meets the requirements before proceeding.",
        "STEP_ONE": {
          "HEADER": "Step 1: Update your Privacy Policy",
          "BODY": "Your privacy policy must clearly describe how your business handles customer data in the context of SMS messaging. It should include:",
          "FIRST_BOLDED": "Data collection: ",
          "FIRST_TEXT": "That your business collects phone numbers for the purpose of sending SMS messages, and what types of messages customers may receive.",
          "SECOND_BOLDED": "Data protection: ",
          "SECOND_TEXT": "How customer data is stored and protected, and how customers can request their data be deleted.",
          "THIRD_BOLDED": "No sharing of phone data: ",
          "THIRD_TEXT": "Phone numbers and messaging data are not shared with, or sold to third parties.",
          "FOURTH_BOLDED": "Rates: ",
          "FOURTH_TEXT": "Message and data rates may apply. Message frequency varies.",
          "FIFTH_BOLDED": "Important: ",
          "FIFTH_TEXT": "The URL you provide must link directly to your privacy policy — not to a homepage or general legal page."
        },
        "STEP_TWO": {
          "HEADER": "Step 2: Update your Terms of Service",
          "BODY": "Your terms of service must cover your SMS messaging practices. Ensure your terms include the following:",
          "FIRST_BOLDED": "Program description: ",
          "FIRST_TEXT": "A description of your SMS messaging program and what messages customers will receive.",
          "SECOND_BOLDED": "Required disclosures: ",
          "SECOND_TEXT": "\"Message and data rates may apply,\" \"Message frequency varies,\" and \"Carriers are not liable for delayed or undelivered messages.\"",
          "THIRD_BOLDED": "Opt-out and help: ",
          "THIRD_TEXT": "Instructions for opting out (e.g., \"Reply STOP to unsubscribe\") and getting help (e.g., \"Reply HELP for assistance\")."
        },
        "STEP_THREE": {
          "HEADER": "Step 3: Add opt-in checkboxes to web forms",
          "BODY": "If you collect phone numbers on your website, your form must include separate consent checkboxes for transactional and marketing messaging.",
          "FIRST_BOLDED": "Transactional consent: ",
          "FIRST_TEXT": "A checkbox confirming the customer agrees to receive service-related messages such as appointment reminders and support updates.",
          "SECOND_BOLDED": "Marketing consent: ",
          "SECOND_TEXT": "A separate checkbox for promotional messages. This checkbox must not be required to complete the form — customers must be able to submit without opting into marketing messages.",
          "THIRD_BOLDED": "Disclosure text: ",
          "THIRD_TEXT": "Both checkboxes should state that message and data rates may apply, message frequency varies, and the customer can reply STOP to unsubscribe at any time."
        },
        "STEP_FOUR": {
          "HEADER": "Step 4: Enable AI chat consent",
          "BODY": "If you use a chat widget on your website, it must also collect consent to send messages via SMS.",
          "FIRST_BOLDED": "Automated consent: ",
          "FIRST_TEXT": "If you use our AI Chat Receptionist, an additional question will be automatically enabled on the Lead Capture capability for accounts submitting A2P registration. The AI will ask: \"Do you agree to receive text messages from us regarding appointments, service updates, and customer support? Message and data rates may apply. Message frequency varies. Reply STOP to unsubscribe or HELP for help to any received SMS messages. Reply Yes if you agree.\"",
          "SECOND_BOLDED": "Proactive verification: ",
          "SECOND_TEXT": "If express written consent has not been collected for a phone number, a single initial SMS may be sent that says, \"[BUSINESS_NAME] would like to send you text messages at this number. Message and data rates may apply. View our SMS policy at [Link]. Reply ‘Yes’ to opt-in.\""
        }
      },
      "EMAIL_SETTINGS": {
        "TITLE": "Email",
        "DESCRIPTION": "Sender info preview",
        "SENDER_PREVIEW_INFO_DESCRIPTION": "The sender name is automatically set as your logged in name and business profile name.",
        "FORWARDING_LEARN_MORE_TITLE": "Assigned email",
        "FORWARDING_LEARN_MORE_DESCRIPTION": "Your email send address for email messages sent out of Conversations, can be configured in email settings.",
        "USER_AT_COMPANY": "{{firstName}} at {{companyName}}",
        "COMPANY_ONLY": "{{companyName}}",
        "CONFIGURE_EMAIL": "Configure email"
      },
      "PERSONAL_EMAIL_SETTINGS": {
        "TITLE": "Personal Email",
        "DESCRIPTION": "Let an AI Employee draft replies to your Gmail and Outlook messages in Conversations. You review and send every draft.",
        "MANAGE": "Manage personal email"
      },
      "MESSAGE_TEMPLATES": {
        "TITLE": "Messaging templates",
        "DESCRIPTION": "Create text messaging templates to save time when responding to messages in Conversations.",
        "GO_TO_MESSAGE_TEMPLATES": "Customize templates",
        "EDIT_TEMPLATE": "Edit template",
        "DELETE_TEMPLATE": "Delete template",
        "TEMPLATE_NAME": "Name",
        "TEMPLATE_CONTENT": "Content",
        "CREATE_TEMPLATE": "Create template",
        "CREATE_TEMPLATE_SUCCESSFUL": "Template is created successfully",
        "CREATE_TEMPLATE_FAILED": "An error occurred while creating the template",
        "TEMPLATE_MISSING_FIELDS": "Some fields are required",
        "UPDATE_TEMPLATE_SUCCESSFUL": "Template is successfully updated",
        "UPDATE_TEMPLATE_FAILED": "An error occurred while updating the template",
        "LOAD_TEMPLATE_FAILED": "An error occurred while loading the template",
        "DELETE_TEMPLATE_MODAL": {
          "TITLE": "Delete template",
          "DESCRIPTION": "Are you sure you want to delete this template?"
        }
      },
      "PLATFORM_ASSISTANT": {
        "SETTINGS_CARD": {
          "TITLE": "Platform Chat",
          "DESCRIPTION": "AI will respond to incoming Platform Chat messages using the knowledge you give it.",
          "ENABLE": "Enable AI assistant for Platform Chat",
          "GO_TO_CONFIGURATION": "Configure Platform Chat",
          "PLATFORM_CHAT_STATUS_UPDATED": "Platform Chat status updated successfully.",
          "PLATFORM_CHAT_STATUS_UPDATE_ERROR": "Error updating Platform Chat status."
        },
        "SETTINGS_PAGE_TITLE": "Platform Chat configuration",
        "KNOWLEDGE_SOURCES": {
          "TITLE": "AI Assistant for Platform Chat",
          "SUBTITLE": "Custom Knowledge"
        },
        "SUSCRIPTION_SELECTOR": {
          "TITLE": "Constrain to subscription level",
          "DESCRIPTION": "AI will respond only to messages from the subscription levels.",
          "PLACEHOLDER": "Select..."
        }
      },
      "WEBCHAT_CONFIGURATION": "Web Chat configuration",
      "WEBCHAT_MISSING_ASSISTANT": {
        "TITLE": "Manage AI workforce",
        "HEADLINE": "No employee assigned",
        "DESCRIPTION": "There is no AI employee assigned to this webchat."
      },
      "INBOX_PRO_CTA": {
        "TITLE": "Installation",
        "HEADING": "Upgrade to get AI Web Chat on your website",
        "VIEW_PRODUCT": "View product"
      }
    },
    "VIEWS": {
      "ALL_CONVERSATIONS": "All conversations",
      "NOTIFICATIONS": "Notifications",
      "SETTINGS": "Settings",
      "TOGGLE_LABEL": "Menu",
      "FOLLOW": "Follow",
      "FOLLOWING": "Following",
      "FAILED_FOLLOW": "Failed change follow status.",
      "SUCCESS_FOLLOW": "You are now following this conversation.",
      "BANNER_INFO_HEADING": "Messaging views are here!",
      "BANNER_INFO_BODY": "Focus on the conversations that matter most to you by adding them to your ★ Following view."
    },
    "DETAILS": {
      "TITLE": "Conversation details",
      "LOADING_ERROR": "Error loading conversation details"
    },
    "TICKETS": {
      "TITLE": "Tickets",
      "VIEW_MORE": "View more",
      "VIEW_LESS": "View less",
      "CREATE": "Create ticket",
      "VIEW": "View ticket",
      "OPEN_TITLE": "Open tickets",
      "CLOSED_TITLE": "Closed tickets",
      "NO_TICKETS": "No {{status}} tickets",
      "NO_TICKETS_DESCRIPTION": "Congratulations you are all caught up",
      "LOAD_MORE": "Load more",
      "ERROR_TICKETS": "Error loading {{status}} tickets. Please refresh."
    },
    "DATE": {
      "TODAY": "Today",
      "YESTERDAY": "Yesterday",
      "AT": "at",
      "MINS_AGO": "mins ago",
      "JUST_NOW": "Just now"
    },
    "EVENTS": {
      "UNSUBSCRIBED": "A recipient unsubscribed from your messages",
      "SUBSCRIBED": "A recipient subscribed to your messages",
      "SENT_BY_YOU": "You",
      "LEAD_CAPTURED": "Form captured",
      "VIEW_ORIGINAL_EMAIL": "View original email",
      "VIEW_CAMPAIGN": "View campaign",
      "CAMPAIGN": {
        "CARD_TITLE": "Campaign {{channel}} delivered"
      },
      "REVIEW_REQUEST": {
        "CARD_TITLE": "Ask for feedback"
      },
      "PHONE": {
        "CARD_TITLE": "Phone Call",
        "CARD_SUBTITLE": "{{ from }} to {{ to }}",
        "MISSED_CALL": "Missed call",
        "TRANSCRIPT": "Call transcript",
        "VIEW_TRANSCRIPT": "View call transcript",
        "AUDIO_PLAYBACK_ERROR": "Audio playback is not supported",
        "VOICE_AI_SETTINGS_LABEL": "Voice AI settings for this call",
        "VOICE_LABEL": "Voice",
        "TURN_DETECTION_THRESHOLD_LABEL": "Turn detection threshold",
        "TURN_DETECTION_PREFIX_PADDING_LABEL": "Turn detection prefix padding",
        "TURN_DETECTION_SILENCE_DURATION_LABEL": "Turn detection silence duration",
        "CALL_END_AI_HUNG_UP": "AI hung up call",
        "CALL_END_AI_TRANSFERRED": "AI transferred call",
        "CALL_END_CALLER_ENDED": "Caller ended call",
        "CALL_END_TIMED_OUT": "Timed out",
        "CALL_END_CARRIER_ERROR": "Carrier error",
        "CALL_END_PROVIDER_ERROR": "Provider error",
        "CALL_END_CONNECTION_ERROR": "Connection error"
      },
      "SMS": {
        "UNSUBSCRIBED_SUBTITLE": "You can no longer send messages to this SMS number because the contact has replied with an unsubscribe word: STOP, STOPALL, UNSUBSCRIBE, CANCEL, END, or QUIT.",
        "SUBSCRIBED_SUBTITLE": "You can now send messages to this SMS number because the the contact has sent a resubscribe word: START, YES or UNSTOP."
      },
      "NPS_FEEDBACK": {
        "CARD_TITLE": "Contact has submitted NPS feedback"
      },
      "REVIEW_MATCHED": {
        "CARD_TITLE": "Contact has left a review"
      },
      "DUPLICATE_CONVERSATION": {
        "TITLE": "A new conversation occurred via {{ channel }}",
        "VIEW": "View"
      }
    },
    "SELECTOR_DIALOG": {
      "SEARCH_FOR_COMPANY": "Search for a company",
      "ACCOUNTS": "Accounts",
      "SEARCH_FOR_CONTACT": "Search for a contact",
      "CONTACTS": "Contacts",
      "CHOOSE_ACCOUNT": "Choose account",
      "CHOOSE_CONTACT": "Choose contact",
      "CREATE_ACCOUNT": "Create account",
      "CREATE_CONTACT": "Create contact",
      "ACCOUNTS_NOT_FOUND": "No accounts found",
      "CONTACTS_NOT_FOUND": "No contacts found"
    },
    "WARNING": {
      "TURN_ON_NOTIFICATIONS": "Turn on notifications ",
      "TURN_ON_NOTIFICATIONS_DETAILS": "— To be notified of new messages in this conversation, turn on \"Only my events\" in your ",
      "NOTIFICATION_SETTINGS": "Notification settings.",
      "NOTIFICATION_UPDATE_SUCCESS": "Notification settings updated successfully",
      "NOTIFICATION_UPDATE_ERROR": "Error updating notification settings",
      "A2P_BANNER_TITLE": "Action required immediately",
      "A2P_BANNER_DESCRIPTION": "SMS messages are being blocked by telecoms for unregistered businesses. Fill out your business details now to minimize downtime of message deliverability.",
      "A2P_BANNER_ACTION": "Update business info",
      "A2P_REJECTED_BANNER_DESCRIPTION": "- Your SMS registration was rejected. Please correct your application and resubmit.",
      "A2P_REJECTED_BANNER_ACTION": "View submission"
    },
    "PERSONAL_EMAIL": {
      "LIST": {
        "TITLE": "Personal Email configuration",
        "MAILBOX": "Mailbox",
        "ASSIGNED_EMPLOYEE": "Assigned Employee",
        "STATUS": "Status",
        "PROVIDER": "Provider",
        "ACTIVE": "Active",
        "INACTIVE": "Inactive",
        "NOT_SET_UP": "Not set up",
        "CONFIGURE": "Configure",
        "DISABLE_DRAFTING": "Disable AI drafting",
        "CONNECT_MAILBOX": "Connect a mailbox",
        "CONFIGURE_SUCCESS": "AI drafting updated for this mailbox",
        "CONFIGURE_ERROR": "Couldn't update AI drafting. Please try again.",
        "DISABLE_SUCCESS": "AI drafting disabled for this mailbox",
        "DISABLE_ERROR": "Couldn't disable AI drafting. Please try again.",
        "DISABLE_CONFIRM_TITLE": "Disable AI drafting?",
        "DISABLE_CONFIRM_MESSAGE": "This removes the assigned AI Employee from this mailbox. You can re-enable it later from Configure.",
        "DISABLE_CONFIRM_BUTTON": "Disable",
        "EMPTY_STATE": {
          "TITLE": "No mailboxes connected",
          "DESCRIPTION": "Connect a Gmail or Outlook mailbox, then assign an AI Employee to start drafting replies."
        }
      }
    },
    "WEBCHAT": {
      "LIST": {
        "EMPTY_STATE": {
          "TITLE": "Create your first Web Chat",
          "DESCRIPTION": "Automate customer interactions with a Web Chat.",
          "DESCRIPTION_MULTI_LOCATION": "Add a widget to a website that allows your customers to select which location they want to chat with. Choose which locations you want included and connect that location's AI Chat Receptionist.",
          "TRY_IT": "Try it"
        },
        "WIDGET": "Widget",
        "ASSIGNED_EMPLOYEES": "Assigned Employees",
        "STATUS": "Status",
        "ACTIONS": "Actions",
        "CREATE": "New Web Chat",
        "EDIT": "Edit",
        "EMBED": "Embed",
        "DELETE": "Delete",
        "NO_ASSIGNED_EMPLOYEE": "No assigned employee",
        "WIDGET_TYPE": "Widget type",
        "STANDARD_WIDGET": "Standard",
        "SYSTEM_WIDGET": "System",
        "SUCCESS_DELETE": "Web chat deleted successfully.",
        "ERROR_DELETE": "Error deleting web chat, please try again."
      },
      "MULTI_LOC_PICKER": {
        "TITLE": "Choose businesses",
        "LOAD_ERROR": "We couldn't load businesses. Please try again.",
        "EMPTY_NO_BUSINESSES": "This brand has no businesses to add.",
        "EMPTY_NO_MATCH": "No businesses match your search.",
        "SEARCH_PLACEHOLDER": "Search",
        "COL_BUSINESS": "Business",
        "COL_STATUS": "Status",
        "AI_DEFAULT_NAME": "Chat Receptionist",
        "AI_INACTIVE": "Conversations AI not active",
        "CANCEL": "Cancel",
        "DONE": "Done"
      },
      "SETTINGS": {
        "INSTALLATION": "Installation",
        "FLOATING_WIDGET_INSTALLATION": "Floating chat widget",
        "EMBEDDED_WIDGET_INSTALLATION": "Embedded chat widget",
        "WIDGET_ACTIONS_INSTALLATION": "Widget actions",
        "WEBCHAT_ACTION": "Select an action",
        "WEBCHAT_ACTION_METHOD": "Select an implementation method",
        "WEBCHAT_ACTION_MESSAGE": "Enter a message",
        "WEBCHAT_ACTION_PREFILL_MESSAGE": "Prefill message",
        "WEBCHAT_ACTION_PREFILL_MESSAGE_INSTRUCTION": "Opens the webchat widget and pre-fills a message in the composer for the user to review before sending",
        "WEBCHAT_ACTION_SEND_MESSAGE": "Send message",
        "WEBCHAT_ACTION_SEND_MESSAGE_INSTRUCTION": "Opens the webchat widget and automatically sends the predefined message without user interaction",
        "WEBCHAT_ACTION_JS_API_INSTALL_INSTRUCTION": "Use this code in your button's onClick handler or any JavaScript event. The webchatAPI is automatically available once the widget script loads.",
        "WEBCHAT_ACTION_ANCHOR_LINK_INSTALL_INSTRUCTION": "Use this URL as an anchor link or redirect target. The widget will automatically detect the hash and trigger the action when the page loads or when the hash changes.",
        "WEBCHAT_ACTION_COPY_THIS_CODE_TO_YOUR_SITE": "Copy this code to your site",
        "WEBCHAT_ACTION_GENERATED_CODE_FOR_YOU": "Generated for you",
        "WEBCHAT_ACTION_NOTE": "Note: The webchat widget must be installed on the page for these actions to work.",
        "WEBCHAT_ACTION_INTEGRATE_METHOD_JS_API": "JavaScript API",
        "WEBCHAT_ACTION_INTEGRATE_METHOD_JS_API_DESCRIPTION": "Call webchat actions programmatically from your JavaScript code. Best for dynamic interactions, buttons, or custom triggers.",
        "WEBCHAT_ACTION_INTEGRATE_METHOD_ANCHOR_LINK_LISTENER": "Anchor link listener",
        "WEBCHAT_ACTION_INTEGRATE_METHOD_ANCHOR_LINK_LISTENER_DESCRIPTION": "Trigger webchat actions via URL hash. Best for direct links, email campaigns, or navigation from external sources.",
        "WEBCHAT_ACTION_QUESTION_DESCRIPTION": "Enter a message that will be used in selected action when the link is clicked. If left empty, the action will open the Web Chat only.",
        "WEBCHAT_ACTION_QUESTION_PLACEHOLDER": "Enter a message (optional)",
        "WEBSITE_INSTALLATION": "Website",
        "WORD_PRESS_INSTALLATION": "WordPress",
        "INSTALL_INSTRUCTIONS": "Copy and paste this code into the head element of your website, typically just before the closing </head> tag.",
        "INSTALL_INSTRUCTIONS_READ_MORE": "Read detailed instructions",
        "GTM_TITLE": "Google Tag Manager",
        "GTM_DESCRIPTION": "You can use this code with Google Tag Manager to embed Web Chat on your site.",
        "WORD_PRESS_INSTALL_INSTRUCTIONS": "Integrate chat into your WordPress site with our easy to use plugin.",
        "WORD_PRESS_INSTALL_INSTRUCTIONS_DETAILS": "Upload and activate this plugin on your website at <strong>yoursite.com/wp-admin/ > Plugins > Add New Plugin</strong>",
        "WORD_PRESS_DOWNLOAD": "Download WordPress plugin",
        "SUCCESS_WORD_PRESS_DOWNLOAD": "Downloaded file saved to {{directory}}",
        "GO_DADDY_TITLE": "GoDaddy Website Builder",
        "GO_DADDY_DESCRIPTION": "When using the GoDaddy website builder, you may need to use a different installation script. This script will make sure the widget appears correctly on your GoDaddy website.",
        "EMBEDDED_WIDGET_INSTALLATION_INSTRUCTIONS": "You can embed the web chat widget directly into your website by adding a container element and specifying its ID in the script tag. This allows the widget to be displayed within a specific section of your webpage, rather than as a floating element.",
        "EMBEDDED_WIDGET_INSTALLATION_INSTRUCTIONS_2": "By default the ID is set to <code>embedded-widget-container</code>, but you can change it to any valid HTML id using the <code>data-embed-target</code> attribute in the script tag. There should only be one ID with this name on the page.",
        "EMBEDDED_WIDGET_INSTRUCTIONS_TITLE": "Instructions",
        "EMBEDDED_WIDGET_INSTRUCTIONS_1": "<strong>Copy and paste</strong> the code below into your webpage (inside the <code>&lt;body&gt;</code>), wherever you want the chat widget to appear.",
        "EMBEDDED_WIDGET_INSTRUCTIONS_1_WORDPRESS": "Using Divi (WordPress): open the page in the <strong>Divi Builder</strong> → add a <strong>Code module</strong> → paste the full snippet → <strong>Save</strong>.",
        "EMBEDDED_WIDGET_INSTRUCTIONS_2": "Optional: adjust the size + layout",
        "EMBEDDED_WIDGET_INSTRUCTIONS_2_WIDTH": "<strong>Width</strong>: change <code>width: 80%</code> to your preferred width (example: <code>100%</code> for full width).",
        "EMBEDDED_WIDGET_INSTRUCTIONS_2_CENTERING": "<strong>Centering</strong>: keep <code>margin: 0 auto;</code> to center the widget container.",
        "EMBEDDED_WIDGET_INSTRUCTIONS_2_HEIGHT": "<strong>Height</strong>: change <code>height: 600px</code> or remove it entirely if you want to control height with your own CSS.",
        "EMBEDDED_WIDGET_INSTRUCTIONS_3": "Optional: add other CSS (like <code>max-width</code>, borders, etc.) directly in the container's <code>style=\"\"</code>.",
        "TITLE": "Web Chat",
        "LOCAL_SEO_TITLE": "My Listing Chat Widget",
        "DESCRIPTION": "Capture new leads from your website with an AI-assisted chat widget.",
        "LEARN_MORE": "Learn more",
        "ENABLED_DESCRIPTION": "Once installed on your website, new leads will appear in your Conversations inbox.",
        "GO_TO_MY_LISTING": "Try it",
        "SETUP_WEBCHAT": "Setup Web Chat",
        "SETUP_REQUIRED": "Setup required",
        "NOT_ACTIVE": "Not active",
        "SOMETHING_WENT_WRONG": "Something went wrong.",
        "WIDGET_NAME": "Widget name",
        "WIDGET_NAME_DESCRIPTION": "A unique name to identify this widget internally.",
        "WEBCHAT_WELCOME_MESSAGE": "Welcome greeting",
        "WEBCHAT_WELCOME_MESSAGE_DESCRIPTION": "This greeting appears on header of the chat widget, to encourage website visitors to engage.",
        "WEBCHAT_WELCOME_MESSAGE_PLACEHOLDER": "Hi, how can we help you today?",
        "WEBCHAT_CUSTOM_GREETING": "Initial AI message",
        "WEBCHAT_CUSTOM_GREETING_DESCRIPTION": "Your AI receptionist will send this initial message when someone interacts with the web chat for the first time.",
        "WEBCHAT_CUSTOM_GREETING_PLACEHOLDER": "Hi there! 👋 I'm here to assist with anything you need. How can I help you today? \n\n ###### *The information you provide in this chat is collected and used to respond to your request and improve our services in accordance with applicable privacy laws.*",
        "LINK_HINT": "Add a link using this format: [Link text Here](https://www.example.com)",
        "APPEARANCE": "Appearance",
        "PRIMARY_COLOR": "Primary color",
        "WEBCHAT_PREVIEW": "Web Chat preview",
        "TEXT_COLOR": "Primary text color",
        "ACCENT_COLOR": "Accent color (send button and chat bubbles)",
        "ACCENT_TEXT_COLOR": "Accent text color",
        "LIGHT": "Light",
        "DARK": "Dark",
        "POSITION": "Web Chat bottom corner position",
        "RIGHT": "Right",
        "LEFT": "Left",
        "INVALID_COLOR": "Invalid format of \"#rrggbb\", where rr, gg, bb are two-digit hexadecimal characters.",
        "DISABLED": "Disabled",
        "ENABLED": "Enabled",
        "FORM_INVALID": "Failed to update widget, please make sure all fields are correct.",
        "MESSAGE_DISABLED_DUPLICATE_CONVERSATION": "You can only respond to this contact at the main conversation",
        "MESSAGE_DISABLED_DUPLICATE_CONVERSATION_ACTION": "Respond",
        "WEBCHAT_UPDATED": "Web Chat updated successfully.",
        "WEBCHAT_UPDATE_ERROR": "Error updating Web Chat.",
        "WEBCHAT_CREATED": "Web Chat created successfully.",
        "WEBCHAT_CREATE_ERROR": "Error creating Web Chat.",
        "WEBCHAT_VALIDATION_ERROR": "Please correct the invalid fields before saving.",
        "WEBCHAT_DISABLED": "Web Chat replies not available.",
        "WEBCHAT_ENABLED_SET": "Web Chat enabled.",
        "WEBCHAT_DISABLED_SET": "Web Chat disabled.",
        "WEBCHAT_ENABLED_FAIL": "Failed to enable Web Chat, please try again.",
        "WEBCHAT_DISABLED_FAIL": "Failed to disable Web Chat, please try again.",
        "WEBCHAT_DISABLED_MISSING_CONTACT_INFO": "You will be able to respond once the web visitor provides their contact information.",
        "WEBCHAT_DISABLED_NO_SMS_PHONE": "Respond to this lead at {{phone}}.",
        "WEBCHAT_DISABLED_NO_SMS_EMAIL": "Respond to this lead at {{email}}.",
        "WEBCHAT_DISABLED_NO_SMS_EMAIL_PHONE": "Respond to this lead at {{phone}} or {{email}}.",
        "WEBCHAT_ASSISTANT_TITLE": "AI employee",
        "WEBCHAT_ASSISTANT_DETAILS": "Employee details",
        "WEBCHAT_ASSISTANT_NAME_HINT": "The name that will appear for the AI employee in the chat widget.",
        "WEBCHAT_ASSISTANT_NAME": "Name",
        "WEBCHAT_ASSISTANT_NAME_TOOLTIP": "Recommended: include a title after your AI employee's name to clearly indicate to users that they are interacting with an AI and not a human employee. If not set, the default designation will be \"Chat Receptionist.\"",
        "WEBCHAT_ASSISTANT_PROFILE_PICTURE": "Profile picture",
        "WEBCHAT_PRIMARY_GOAL": "Primary goal",
        "WEBCHAT_ADDITIONAL_INSTRUCTIONS": "Additional instructions",
        "WEBCHAT_ADDITIONAL_INSTRUCTIONS_DESCRIPTION": "Add any additional instructions for your AI employee to follow.",
        "WEBCHAT_ADDITIONAL_INSTRUCTIONS_LIMIT_EXCEEDED": "Too many characters",
        "WEBCHAT_ASSISTANT": {
          "DESCRIPTION": "The AI will reply to messages sent to this web chat widget. Customize it separately.",
          "CONFIGURE": "Configure"
        },
        "LOCATIONS_TITLE": "Businesses included",
        "LOCATIONS_DESCRIPTION": "Visitors will see this list of businesses in the widget's location picker. Businesses without Conversations AI active can't be included.",
        "LOCATIONS_ADD": "Add locations",
        "LOCATIONS_EDIT": "Edit locations",
        "LOCATIONS_COUNT": "{{count}} businesses included",
        "ENABLE_LEAD_CAPTURE": {
          "DESCRIPTION": "Lead capture",
          "INFORMATION": "The AI will prioritize getting a name and contact information, create a new contact, and let the user know someone on your team will follow up."
        },
        "IMAGE_UPLOAD": {
          "REMOVE_IMAGE": "Remove image",
          "HINT": "Pick an employee profile picture."
        },
        "ENABLE_LEAD_CAPTURE_DIALOG": {
          "INFORMATION": "Lead Capture: The AI receptionist politely asks each visitor for their name and at least one contact detail (phone preferred, email as fallback). Once any contact info is shared, it creates a new CRM contact and, five minutes later, sends your team a “new lead” notification with a chat summary. If Lead Capture is disabled, the AI still answers questions but won’t request contact details or create CRM records; chats with contact info remain as Anonymous Web Visitors.",
          "INFORMATION_2": "Captured and stored when present: Name (first, last), Contact (phone, email), Address (street, city, state/province, postal code, country), Record source (current page URL), and UTM parameters (campaign, medium, source, content).",
          "INFORMATION_3": "Need different or extra information? Add a custom capability with your additional questions or rules—for example, “Also ask for address” —then save; the AI will follow both the built-in Lead Capture rules and your custom instructions."
        },
        "ADDITIONAL_INSTRUCTIONS_DIALOG": {
          "TITLE": "Additional instructions information",
          "INFORMATION_WARNING": "Warning:",
          "INFORMATION": "These instructions will affect the main instructions and conversational behavior of your AI employee. Make sure to test your employee thoroughly after making any changes, because this has the potential for unintended consequences for your AI employee's behavior. Use plain text or markdown format.",
          "EXAMPLE_HEADING": "Example instructions that you can use:",
          "EXAMPLE_1": "Link sharing: Describe when the AI employee should direct someone to a link, like if they want to book a meeting or create a support ticket.",
          "EXAMPLE_2": "Ask additional qualifying questions, like if the user is within service area, or more details about their project.",
          "EXAMPLE_3": "Adjust the employee's tone and personality, to match your brand voice.",
          "EXAMPLE_4": "Localizations – for example, you could ask it to use British English instead of American English.",
          "EXAMPLE_5": "Adjust the conversation flow, like ask for both the phone number and email address, or ask for the email address first.",
          "EXAMPLE_6": "Ask for additional contact fields; these fields will be added to the contact if found within the conversation:",
          "FIELD_1": "First name",
          "FIELD_2": "Last name",
          "FIELD_3": "Phone number",
          "FIELD_4": "Email address",
          "FIELD_5": "Address",
          "FIELD_6": "City",
          "FIELD_7": "State/Province",
          "FIELD_8": "Zip/Postal code",
          "FIELD_9": "Country",
          "DO_NOT_WORK_HEADING": "Instructions that do not work yet:",
          "DO_NOT_WORK_DESCRIPTION": "You cannot make the AI employee perform actions outside of the conversation. For example, you cannot say \"If a customer asks for [employee], then notify that user.\""
        },
        "BUSINESS_PROFILE": {
          "BUSINESS_PROFILE": "Business Profile",
          "ALLOW_ACCESS": "Allow access to your business profile",
          "DESCRIPTION": "Answer questions about your business contact information, hours, products and services you offer.",
          "MANAGE_BUSINESS_PROFILE": "Manage business profile",
          "LEARN_MORE": {
            "TITLE": "Learn more",
            "WHAT_INFORMATION_QUESTION": "What information is made available to your AI employee?",
            "WHAT_INFORMATION": "These fields are shared from your business profile:",
            "BUSINESS_NAME": "Business name",
            "ADDRESS_SERVICE_AREAS": "Address and/or service areas",
            "WEBSITE": "Website",
            "PHONE_NUMBER": "Phone number",
            "CATEGORIES": "Categories",
            "HOURS": "Hours",
            "SERVICES_OFFERED": "Services offered",
            "SHORT_DESCRIPTION": "Short description",
            "LONG_DESCRIPTION": "Long description",
            "SOCIAL_MEDIA_URLS": "Social media URLs",
            "BOOKING_URL": "Booking URL"
          }
        },
        "CUSTOM_KNOWLEDGE": {
          "AI_KNOWLEDGE_BASE": "AI knowledge base",
          "MANAGE_KNOWLEDGE": "Manage knowledge",
          "MANAGE_KNOWLEDGE_DESCRIPTION": "Create and manage facts and information that can be added to AI employees",
          "REFRESH_OPTIONS": "Refresh options",
          "CHOOSE_KNOWLEDGE_SOURCES": "Answer questions using provided knowledge:",
          "KNOWLEDGE_SOURCES": "Knowledge sources",
          "ADD_KNOWLEDGE": "Add knowledge",
          "SELECT_KNOWLEDGE": "Select knowledge",
          "CUSTOM_KNOWLEDGE": "Q&A",
          "DESCRIPTION": "Provide additional facts and answers to frequently asked questions your Chat Receptionist can use when responding to inquiries.",
          "MAX_CHARACTER_EXCEEDED": "Maximum character limit exceeded",
          "APPLICATION_SETTINGS": "Settings",
          "APPS_WARNING": "This knowledge is currently being used by the following:",
          "NO_APPS": "This knowledge is not currently being used.",
          "EDIT": {
            "TITLE": "Custom knowledge",
            "NAME": "Name",
            "CONTENT": "Content"
          },
          "DELETE": {
            "TITLE": "Delete custom knowledge?"
          }
        },
        "MOBILE_CTA_TITLE": "Mobile Call-to-Action Popup",
        "MOBILE_CTA_DESCRIPTION": "Display the message popup on mobile screens of new website visitors. When unchecked, only the circular chat button will appear.",
        "MANAGE_WIDGETS": "Manage widgets"
      },
      "WIDGET": {
        "POWERED_BY": "Chat powered by",
        "WE_RESPOND_IMMEDIATELY": "We respond immediately",
        "SEND": "Send",
        "SENDING_DISABLED_FOR_PREVIEW": "Sending disabled for preview",
        "DEFAULT_ASSISTANT_NAME": "Chat Receptionist",
        "TOGGLE_WIDGET": "Toggle web chat widget",
        "CLOSE_WIDGET": "Close web chat widget",
        "SUPPORT_AGENT": "Support Agent"
      },
      "LEARN_MORE": {
        "TITLE": "Learn more",
        "WHAT_CAN_DO_QUESTION": "What can an AI-assisted web chat widget do for my business?",
        "WHAT_CAN_DO_ANSWER": "Installing an AI-assisted web chat widget on your business website can help you capture more leads at any time of day, even when you are not available to respond immediately. Your AI employee will instantly respond to customers on your behalf, with the goals of answering questions about your business and obtaining their name and contact information so you can follow up at a time that suits you.",
        "HOW_IT_WORKS_QUESTION": "How does my AI Agent work?",
        "HOW_IT_WORKS_ANSWER": "Your AI employee will act as a first responder to any website leads, answering questions and providing a professional and courteous first impression for your business. The AI will attempt to get the lead's contact info, requesting the website visitor's name, mobile number, or email. Your AI employee can answer questions about your business using knowledge it's been granted access to from your business profile, custom text snippets, and your website. The AI has been given strict instructions to only answer about things it's confident about and will not step outside of these bounds. You can monitor all conversations in real-time via your Conversations inbox, providing complete transparency of the historical context prior to outreach. When you respond, you can do so via email or SMS (where available) directly from your Conversations Inbox, allowing you to continue the conversation off the website and onto their phone.",
        "WHAT_HAPPENS_QUESTION": "What happens when a new lead is captured?",
        "WHAT_HAPPENS_ANSWER": "When a new lead's contact information is captured by the AI employee, a new contact will be created in your CRM, and you'll be notified – all users on your account who are subscribed to the \"new lead\" notification can get an app or email notification. You can also take advantage of automations and integrations to further streamline your lead nurturing flows.",
        "HOW_TO_GET_MOST_QUESTION": "How do I get the most from my AI-assisted Chat Widget?",
        "HOW_TO_GET_MOST_ANSWER": "The more website visitors you have, the more opportunity you have to capture a new lead. By improving your website's search engine optimization (SEO) and driving traffic to your website through paid advertising, you'll increase the effectiveness of your chat widget, which can result in more leads! Make sure someone from your team is reaching out to new leads as quickly as possible – every moment that passes without a response from your team is a moment that the lead could choose to go to another business. Don't lose the lead – respond quickly! Consider using an automation to immediately send the lead a message via email or SMS.",
        "HOW_TEST_IT_QUESTION": "How can I test it?",
        "HOW_TEST_IT_ANSWER": "You may have access to a demo \"My Listing\" chat widget, which is automatically created and trained on your business information – try adding additional knowledge and seeing how your AI employee answers your questions. You can also install the chat widget on a private or low-traffic web page and try chatting with it there before going live on your homepage. You'll see it's an exciting way to drive new business for your company, 24/7."
      },
      "DELETE_DIALOG": {
        "TITLE": "Delete web chat",
        "DESCRIPTION": "Are you sure you want to delete '{{widgetName}}'? Any site that has installed this web chat will no longer have access to it. This action cannot be undone.",
        "CANCEL": "Cancel",
        "DELETE": "Delete"
      }
    },
    "BETA": {
      "TRY_NEW_UI": "Try the new filtered inbox (beta)",
      "TRY_NEW_UI_SHORT": "Try filtered inbox (beta)",
      "TRY_IT": "Try it",
      "SWITCH_BACK": "Switch back to classic inbox",
      "FEEDBACK_TITLE": "What could be better?",
      "FEEDBACK_PLACEHOLDER": "Tell us why you're switching back (optional)",
      "SUBMIT_AND_SWITCH": "Send & switch back"
    },
    "FILTERS": {
      "FILTER_BUTTON": "Filter",
      "INBOX": "Inbox",
      "ANONYMOUS": "Anonymous",
      "CLOSED": "Closed",
      "PRIVATE": "Private",
      "CHANNEL": "Channel",
      "CHANNEL_SMS": "SMS",
      "CHANNEL_EMAIL": "Email",
      "CHANNEL_WEB_CHAT": "Web Chat",
      "CHANNEL_FACEBOOK": "Facebook",
      "CHANNEL_INSTAGRAM": "Instagram",
      "CHANNEL_WHATSAPP": "WhatsApp",
      "UNREAD": "Unread",
      "AWAITING_RESPONSE": "Awaiting response",
      "NEEDS_REPLY": "Needs reply",
      "ASSIGNED_TO_ME": "Assigned to me",
      "UNASSIGNED": "Unassigned",
      "STATUS": "Status",
      "STATUS_ALL": "All status",
      "CLEAR_ALL": "Clear filters",
      "NO_RESULTS": "No conversations match your filters"
    },
    "RESPONSE_EVALUATION": {
      "HELPFUL": "Helpful",
      "HELPFUL_QUESTION": "What about this response was helpful?",
      "NOT_HELPFUL": "Not helpful",
      "NOT_HELPFUL_QUESTION": "What about this response was not helpful?"
    },
    "INBOX_ZERO": {
      "TITLE": "Great work!",
      "DESCRIPTION": "You have closed all your conversations.",
      "START_A_NEW_CONVERSATION": "Start a new conversation"
    },
    "MULTI_LOCATION": {
      "MULTI_LOCATION_SUBTITLE": "Chat with customers across all locations in this group.",
      "MULTI_LOCATION_BUTTON": "Start using multi-location Conversations",
      "SUCCESS_TO_OPT_IN": "You are now able to use Conversations for this group. Please wait while conversations are loaded.",
      "FAIL_TO_OPT_IN": "Opting in failed",
      "INBOX_INFO": "Interact with all conversations from all accounts in this group. Note, contacts and notifications are managed at single-location."
    },
    "CITATIONS": {
      "INTERNAL_ONLY": "Explanations and sources are only visible to users at your organization.",
      "CROSS_NAMESPACE_TOOLTIP": "This source is in another workspace and can't be opened here.",
      "SOURCE_MATERIAL": "Explanation",
      "THINKING_TITLE": "Thinking",
      "THOUGHTS_TITLE": "Thoughts",
      "THOUGHTS_SHOW": "Show thinking",
      "FUNCTION": {
        "REQUEST_PARAMETERS": "Request parameters",
        "REQUEST_URL": "Request URL",
        "RESPONSE": "Response",
        "RESPONSE_TOO_LARGE": "Response too large to display. Large responses (over {{ maxKilobytes }}KB) may cause issues with AI. Consider using filters or pagination on the tool call to reduce the size.",
        "HEADERS": "Headers",
        "COPY_AS_CURL": "Copy as cURL",
        "LOAD_ERROR": "Failed to load function call details."
      }
    },
    "WEBSITE_PREVIEW": {
      "PREVIEW_TITLE": "Website Preview",
      "NO_FILE_ERROR": "No file URL provided for preview",
      "SCRAPED_CONTENT_WARNING": "This is a preview of text content that was previously captured from the website. The layout and styling may look very different from the actual site, and images or links may not work. We only process the text content for our AI, not the visual design or images.",
      "VIEW_LIVE_SITE": "View live site ↗",
      "UNSUPPORTED_TYPE_ERROR": "This citation type is not supported for preview. Only website citations can be previewed."
    },
    "CONTACT_ASSISTANT": {
      "SUPPORT_AI_TITLE": "Need help fast?",
      "SUPPORT_AI_BUTTON_TEXT": "Chat with Vendasta AI",
      "SUPPORT_AI_BANNER_DESCRIPTION": "Chat with Vendasta AI for instant answers. Want a human? Just type \"Speak with support\" to reach our team directly."
    },
    "VIDEO": {
      "STATUS": {
        "UPLOADING": "Uploading...",
        "PROCESSING": "Processing...",
        "SENDING": "Sending..."
      },
      "ACTION": {
        "CANCEL": "Cancel",
        "RETRY": "Retry",
        "DISMISS": "Dismiss"
      },
      "ERROR": {
        "FAILED": "Something went wrong with this video.",
        "UPLOAD_REJECTED": "This video can't be sent via SMS. It may be too long or an unsupported format.",
        "TRANSCODING_FAILED": "We couldn't process your video. Try again with a shorter or smaller video.",
        "OUTPUT_TOO_LARGE": "Your video was too large to send even after processing.",
        "TWILIO_REJECTED": "Your video couldn't be sent. Try a shorter video.",
        "UNKNOWN": "Something went wrong with this video message."
      }
    }
  }
}
